import React, {Context, useContext} from "react";
import {GridComponentColumnProps} from "../../../core/_models";

type Props = {
    column: GridComponentColumnProps
    context: Context<any>
    additionalRequestData?: { [key: string]: any }
    row: any
}

export function BooleanGridColumnComponent({column, context, additionalRequestData, row}: Props) {
    const {action} = column;

    const formContext = useContext(context);

    return (
        <div className={`w-100 text-center ${action != null ? 'cursor-pointer' : ''}`} onClick={(e) => {
            if (action != null) {
                const values = {...additionalRequestData};
                formContext.submit({action, values})
            }
        }}>
            {row[column.field] === true &&
                <i className='fas fa-check-circle text-primary'/>}
            {row[column.field] === false &&
                <i className='fas fa-xmark text-danger'/>}
        </div>
    )
}